import { TokenState, TokenActions } from './types'
import { Constants } from './constants'
import { ethers } from 'ethers'
import { TTokenType } from 'types'
import { BigNumber } from 'ethers'

const initialState: TokenState = {
  loading: false,
  name: '',
  description: '',
  image: null,
  decimals: 0,
  balance: ethers.BigNumber.from(0),
  address: null,
  tokenId: null,
  amount: BigNumber.from(0),
  tokenType: 'ERC20' as TTokenType
}

export function tokenReducer(
  state: TokenState = initialState,
  action: TokenActions
): TokenState {
    switch (action.type) {
        case Constants.TOKEN_SET_NAME:
          return {...state, name: action.payload.name }
        case Constants.TOKEN_SET_DESCRIPTION:
          return {...state, description: action.payload.description }
        case Constants.TOKEN_SET_IMAGE:
          return {...state, image: action.payload.image }
        case Constants.TOKEN_SET_DECIMALS:
          return {...state, decimals: action.payload.decimals }
        case Constants.TOKEN_SET_ADDRESS:
          return {...state, address: action.payload.address }
        case Constants.TOKEN_SET_AMOUNT:
            return {...state, amount: action.payload.amount }
        case Constants.TOKEN_SET_TOKEN_ID:
          return {...state, tokenId: action.payload.tokenId }
        case Constants.TOKEN_SET_BALANCE:
          return {...state, balance: action.payload.balance }
        case Constants.TOKEN_SET_TOKEN_TYPE:
          return {...state, tokenType: action.payload.tokenType }
        default:
            return state;
    }
}